<template>
<div>
  <div class="table-responsive" @contextmenu.prevent="$refs.ctxMenu.open">
    <slot></slot>
  </div>
  <!-- <context-menu id="context-menu" ref="ctxMenu" @ctx-open="onCtxOpen">
    <li v-show="hidenColumns.length>0">
      <ul>
        <li v-for="column in hidenColumns" @click="revealColumn(column)">
          <span>{{$t('tables.showColumn')}}: {{ column }} <i class="fa fa-eye"></i></span>
        </li>
      </ul>
    </li>
    <li @click="hideColumn" class="hover-bg"><span>{{$t('tables.hideColumn')}} <i class="fa fa-eye-slash"></i></span></li>
  </context-menu> -->
</div>

</template>
<script>
import contextMenu from 'vue-context-menu'
export default {
  name: 'xmenu',
  components: {
    'context-menu': contextMenu,
  },
  data() {
    return {
      hidenColumns: []
    }
  },
  computed: {
    mainTable() {
      return this.$slots.default[0].context
    },
    currentColName() {
      return this.mainTable.opts.currentCell.columnName
    }
  },
  methods: {
    seeData() {
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      console.log(this.mainTable)
      console.log(this.mainTable.opts.currentCell)
      console.log(this.currentColName)
      console.log(this.mainTable.columns)
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
    },
    hideColumn() {

      if ((this.mainTable.columns.length - this.hidenColumns.length) < 2)
        return

      let name = this.mainTable.opts.currentCell.columnName
      let idx = this.mainTable.columns.indexOf(name)
      let searchKey = 'C' + idx

      this.hidenColumns.push(this.mainTable.columns[idx])

      for (let item in this.mainTable.$refs) {

        if (item.indexOf(searchKey) > -1) {
          let obj = this.mainTable.$refs[item]

          if (obj.className.indexOf('hide') === -1) {
            obj.className += ' hide'
          }
        }
      }
    },

    revealColumn(name) {

      let idx = this.mainTable.columns.indexOf(name)
      let searchKey = 'C' + idx

      for (let item in this.mainTable.$refs) {
        if (item.indexOf(searchKey) > -1) {
          let obj = this.mainTable.$refs[item]
          obj.className = obj.className.replace('hide', '')
        }
      }

      this.removeHideColumn(name)

    },
    removeHideColumn(name){
      let idx = this.hidenColumns.indexOf(name)

      if (idx !== -1)
        this.hidenColumns.splice(idx, 1)

    },
    onCtxOpen(locals) {
      console.log('open', locals)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vuetable-2-kernel/compiled/template/contextualMenu.vue